import DadosAdicionaisFichaTecnica from "../models/dadosAdicionaisFichaTecnicaModel";

import { IService } from "./base/iService";

export default class DadosAdicionaisFichaTecnicaService extends IService<DadosAdicionaisFichaTecnica> {
    constructor() {
        super("DadosAdicionaisFichaTecnica");
    }
}